<template>
  <b-container>
    <b-card v-if="wardId === null">
      <router-link :to="{ name: 'stake-list' }" active>
        Back to Stake
      </router-link>
      <h4>Create a new Congregation.{{ wardId }}</h4>
    </b-card>
    <b-card v-if="wardId !== null">
      <b-breadcrumb>
        <b-breadcrumb-item
          :to="{ name: 'ward-list', params: { wardId: wardId } }"
          >Back to {{ ward.ward_name }}</b-breadcrumb-item
        >
        <b-breadcrumb-item active
          >Modify {{ ward.ward_name }} Info</b-breadcrumb-item
        >
      </b-breadcrumb>
      <h1>Name: {{ ward.ward_name }}</h1>
    </b-card>
    <b-card>
      <b-form @submit="onSubmit">
        <b-form-group
          id="input-group-1"
          label="Name:"
          label-for="input-1"
          description="Name."
        >
          <b-form-input
            id="input-1"
            v-model="ward.ward_name"
            type="text"
            placeholder="Enter Name"
            required
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="City:"
          label-for="input-2"
          description="City where Congregation is located"
        >
          <b-form-input
            id="input-2"
            v-model="ward.ward_city"
            type="text"
            placeholder="Enter City Name"
            required
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="Twilio Phone Number:"
          label-for="input-3"
          description="Phone number that is used to send SMS messages,(Must be a twilio phone number)"
        >
          <b-form-input
            id="input-3"
            v-model="ward.twilio_phone_number"
            type="tel"
            placeholder="Enter Twilio Phone Number"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-4"
          label="Twilio ID:"
          label-for="input-4"
          description="Twilio Application Id to use for sending sms"
        >
          <b-form-input
            id="input-4"
            v-model="ward.twilio_id"
            type="text"
            placeholder="Enter Twilio Application ID"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-5"
          label="Twilio Secret:"
          label-for="input-5"
          description="Twilio Application Password to use for sending sms"
        >
          <b-form-input
            id="input-5"
            v-model="ward.twilio_password"
            type="text"
            placeholder="Enter Twilio Application Secret/Password"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-10"
          label="Congregation Type"
          label-for="input-group-10"
          description="Type of congregation, mainly used to strip out organizations on creation."
        >
          <b-form-select
            v-model="ward.ward_type"
            :options="wardTypeOptions"
          ></b-form-select>
        </b-form-group>
        <b-tabs class="mt-3" content-class="mt-3">
          <b-tab title="Languages" active>
            <b-form-group
              id="input-group-110"
              label="Ward TimeZone"
              label-for="input-group-110"
              description="The timezone for the ward, this is necessary to use the appoinment features.."
            >
              <b-form-select
                v-model="ward.ward_timezone"
                :options="wardTimeZoneOptions"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              label="Congregation Supported Languages"
              label-for="tags-component-select"
            >
              <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
              <b-form-tags
                id="tags-component-select"
                v-model="ward.supported_languages"
                size="lg"
                class="mb-2"
                add-on-change
                no-outer-focus
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    disabled,
                    removeTag
                  }"
                >
                  <ul
                    v-if="tags.length > 0"
                    class="list-inline d-inline-block mb-2"
                  >
                    <li v-for="tag in tags" :key="tag" class="list-inline-item">
                      <b-form-tag
                        @remove="removeTag(tag)"
                        :title="tag"
                        :disabled="disabled"
                        variant="info"
                        >{{ tag }}</b-form-tag
                      >
                    </li>
                  </ul>
                  <b-form-select
                    v-bind="inputAttrs"
                    v-on="inputHandlers"
                    :disabled="
                      disabled || availableLanguageOptions.length === 0
                    "
                    :options="availableLanguageOptions"
                  >
                    <template #first>
                      <!-- This is required to prevent bugs with Safari -->
                      <option disabled value="">Choose Languages</option>
                    </template>
                  </b-form-select>
                </template>
              </b-form-tags>
            </b-form-group>
          </b-tab>
          <b-tab title="Appointments">
            <b-form-group
              label="Ward Appointment Types Supported"
              label-for="tags-component-select-1"
            >
              <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
              <b-form-tags
                id="tags-component-select-1"
                v-model="ward.appointments_available"
                size="lg"
                class="mb-2"
                add-on-change
                no-outer-focus
              >
                <template
                  v-slot="{
                    tags,
                    inputAttrs,
                    inputHandlers,
                    disabled,
                    removeTag
                  }"
                >
                  <ul
                    v-if="tags.length > 0"
                    class="list-inline d-inline-block mb-2"
                  >
                    <li v-for="tag in tags" :key="tag" class="list-inline-item">
                      <b-form-tag
                        @remove="removeTag(tag)"
                        :title="tag"
                        :disabled="disabled"
                        variant="info"
                        >{{ tag }}</b-form-tag
                      >
                    </li>
                  </ul>
                  <b-form-select
                    v-bind="inputAttrs"
                    v-on="inputHandlers"
                    :disabled="
                      disabled || availableAppointmentTypes.length === 0
                    "
                    :options="availableAppointmentTypes"
                  >
                    <template #first>
                      <!-- This is required to prevent bugs with Safari -->
                      <option disabled value="">Choose Appointments</option>
                    </template>
                  </b-form-select>
                </template>
              </b-form-tags>
            </b-form-group>

            <b-form-group
              label="Public Ward Appointment Hours (per day)"
              description="Configure available hours for each day. If a day has no hours, it will be disabled."
            >
              <b-card
                v-for="(dayName, dayIndex) in dayNames"
                :key="dayName"
                no-body
                class="mb-2"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    v-b-toggle="`hours-accordion-${dayIndex}`"
                    block
                    variant="link"
                    class="text-left font-weight-bold"
                  >
                    {{ dayName }}
                    <b-badge
                      v-if="getDayHours(dayName).length > 0"
                      variant="info"
                      class="ml-2"
                    >
                      {{ getDayHours(dayName).length }} time{{ getDayHours(dayName).length !== 1 ? 's' : '' }}
                    </b-badge>
                  </b-button>
                </b-card-header>
                <b-collapse
                  :id="`hours-accordion-${dayIndex}`"
                  :accordion="`hours-accordion`"
                  role="tabpanel"
                >
                  <b-card-body>
                    <div v-for="(hour, hourIndex) in getDayHours(dayName)" :key="hourIndex" class="mb-2">
                      <b-input-group>
                        <b-form-input
                          v-model="ward.public_appointment_hours[dayName][hourIndex]"
                          type="time"
                          placeholder="HH:MM (24-hour format)"
                          :pattern="'^([0-1][0-9]|2[0-3]):[0-5][0-9]$'"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="danger"
                            @click="removeHour(dayName, hourIndex)"
                            :disabled="getDayHours(dayName).length <= 1"
                          >
                            Remove
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="addHour(dayName)"
                    >
                      Add Time Slot
                    </b-button>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-form-group>

            <b-form-group
              label="Public Appointment Types & Defaults"
              description="Add appointment types and configure their defaults. Types added here will be available for public booking."
            >
              <div class="mb-3">
                <b-form-group
                  label="Add Appointment Type"
                  description="Select an appointment type to add for public booking"
                >
                  <b-form-select
                    v-model="selectedAppointmentTypeToAdd"
                    :options="availableAppointmentTypesToAdd"
                    @change="addAppointmentType"
                  >
                    <template #first>
                      <option :value="null" disabled>Choose an appointment type to add</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>

              <div v-if="appointmentTypesInDefaults.length > 0">
                <b-card
                  v-for="(appointmentType, index) in appointmentTypesInDefaults"
                  :key="appointmentType"
                  no-body
                  class="mb-2"
                >
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="d-flex justify-content-between align-items-center">
                      <b-button
                        v-b-toggle="`accordion-${index}`"
                        variant="link"
                        class="text-left font-weight-bold flex-grow-1"
                      >
                        {{ getAppointmentTypeDescription(appointmentType) }}
                      </b-button>
                      <b-button
                        variant="danger"
                        size="sm"
                        @click="removeAppointmentType(appointmentType)"
                        class="ml-2"
                      >
                        Remove
                      </b-button>
                    </div>
                  </b-card-header>
                  <b-collapse
                    :id="`accordion-${index}`"
                    :accordion="`appointment-defaults-accordion`"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-form-group
                        label="Default Organizer"
                        :label-for="`organizer-${appointmentType}`"
                        description="Search for a contact to set as the default organizer for this appointment type"
                      >
                        <v-multiselect
                          :id="`organizer-${appointmentType}`"
                          v-model="getDefaultForType(appointmentType).organizer"
                          :options="getContactSearchResults(appointmentType)"
                          :custom-label="contactPrettyDisplay"
                          placeholder="Type to search ward contacts"
                          label="full_name"
                          track-by="contact_id"
                          :internal-search="false"
                          :show-no-results="true"
                          :loading="getContactSearchLoading(appointmentType)"
                          :showNoOptions="false"
                          @search-change="(term) => searchContacts(term, appointmentType)"
                          @open="() => clearSearchResults(appointmentType)"
                        >
                          <span slot="noResult">Oops! No contacts found!.</span>
                        </v-multiselect>
                      </b-form-group>

                      <b-form-group
                        label="Notification Emails"
                        :label-for="`emails-${appointmentType}`"
                        description="Additional email addresses to notify when this appointment type is booked (comma-separated)"
                      >
                        <b-form-tags
                          :id="`emails-${appointmentType}`"
                          v-model="getDefaultForType(appointmentType).emails"
                          add-on-change
                          no-outer-focus
                          placeholder="Enter email addresses"
                          separator=","
                          class="mb-2"
                        >
                          <template
                            v-slot="{
                              tags,
                              inputAttrs,
                              inputHandlers,
                              disabled,
                              removeTag
                            }"
                          >
                            <ul
                              v-if="tags.length > 0"
                              class="list-inline d-inline-block mb-2"
                            >
                              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                <b-form-tag
                                  @remove="removeTag(tag)"
                                  :title="tag"
                                  :disabled="disabled"
                                  variant="info"
                                  >{{ tag }}</b-form-tag
                                >
                              </li>
                            </ul>
                            <b-form-input
                              v-bind="inputAttrs"
                              v-on="inputHandlers"
                              :disabled="disabled"
                              placeholder="Enter email and press Enter"
                            ></b-form-input>
                          </template>
                        </b-form-tags>
                      </b-form-group>

                      <b-form-group
                        label="Available Days"
                        :label-for="`days-${appointmentType}`"
                        description="Select which days this appointment type is available. If no days are selected, all days with configured hours will be available."
                      >
                        <b-form-tags
                          :id="`days-${appointmentType}`"
                          v-model="getDefaultForType(appointmentType).availableDays"
                          add-on-change
                          no-outer-focus
                          placeholder="Select days"
                          class="mb-2"
                        >
                          <template
                            v-slot="{
                              tags,
                              inputAttrs,
                              inputHandlers,
                              disabled,
                              removeTag
                            }"
                          >
                            <ul
                              v-if="tags.length > 0"
                              class="list-inline d-inline-block mb-2"
                            >
                              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                <b-form-tag
                                  @remove="removeTag(tag)"
                                  :title="tag"
                                  :disabled="disabled"
                                  variant="info"
                                  >{{ tag }}</b-form-tag
                                >
                              </li>
                            </ul>
                            <b-form-select
                              v-bind="inputAttrs"
                              v-on="inputHandlers"
                              :disabled="disabled"
                              :options="availableDayOptions"
                            >
                              <template #first>
                                <option :value="null" disabled>Select a day</option>
                              </template>
                            </b-form-select>
                          </template>
                        </b-form-tags>
                      </b-form-group>

                      <b-form-group
                        label="Maximum Appointments per Slot"
                        :label-for="`max-appointments-${appointmentType}`"
                        description="Maximum number of appointments allowed at the same time when no organizer is set (default: 3)"
                      >
                        <b-form-input
                          :id="`max-appointments-${appointmentType}`"
                          v-model.number="getDefaultForType(appointmentType).maxAppointments"
                          type="number"
                          min="1"
                          placeholder="3"
                          class="mb-2"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Appointment Duration"
                        :label-for="`duration-${appointmentType}`"
                        description="Duration in minutes for this appointment type (5-60 minutes, increments of 5)"
                      >
                        <b-form-spinbutton
                          :id="`duration-${appointmentType}`"
                          v-model="getDefaultForType(appointmentType).duration"
                          min="5"
                          max="60"
                          step="5"
                          placeholder="15"
                          class="mb-2"
                        ></b-form-spinbutton>
                      </b-form-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <div v-else class="text-muted">
                <p>No appointment types configured. Add an appointment type above to get started.</p>
              </div>
            </b-form-group>
          </b-tab>
          <b-tab title="Messages">
            <b-form-checkbox
              v-model="ward.auto_reply_sms"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Auto reply when receiving SMS (<i
                >Does not apply to Subscribe/Unsubscribe messages</i
              >)
            </b-form-checkbox>
            <b-form-checkbox
              v-if="ward.auto_reply_sms"
              v-model="ward.use_ward_org_for_inbound"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              User Ward Org for all Inbound Text Message, default is use contact
              primary organization.
            </b-form-checkbox>
            <b-form-checkbox
              v-model="ward.send_consent"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Send a consent message opt-in when contacts are created.
            </b-form-checkbox>
            <b-form-checkbox
              v-model="ward.throttle_sending_sms"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Throttle the SMS sending to service.<i
                >This can help if your messages are being filtered by a
                carrier</i
              >.
            </b-form-checkbox>
            <b-form-checkbox
              v-model="ward.enable_gsm_optimization"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Enable GSM Optimization.<i
                >When enabled the system will try convert UCS to GSM where
                possible. Helpfull for non Latin languages.</i
              >
            </b-form-checkbox>
            <div v-if="ward.throttle_sending_sms">
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-7"
                    label="Interval in minutes:"
                    label-for="input-7"
                    description="Interval to release messages in minutes. We have 5 minutes to be good enough. Minimal is 5 minutes and max is 60 minutes"
                  >
                    <b-form-spinbutton
                      id="sb-group-7"
                      v-model="ward.throttle_interval_minutes"
                      min="5"
                      max="60"
                      step="5"
                    ></b-form-spinbutton>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-6"
                    label="Max segments per Interval:"
                    label-for="input-6"
                    description="The total segments to release per interval. We have found 60 to be a good number"
                  >
                    <b-form-input
                      id="input-6"
                      v-model="ward.throttle_max_messages"
                      type="number"
                      placeholder="60"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Twilio">
            <b-form-checkbox
              v-model="ward.twilio_test"
              name="check-button"
              switch
            >
              Twilio Test(Will simulate but not actually send messages)
            </b-form-checkbox>
            <b-form-checkbox
              v-model="ward.fetch_contact_carrier"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Fetch carrier info when creating contact.<i
                >Please note there is a cost
                <b-badge variant="danger">$0.005</b-badge> per contact
                lookup.</i
              >
            </b-form-checkbox>
            <b-form-checkbox
              v-model="ward.whatsapp_service_enabled"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Whatsapp Service Enabled.<i
                >You must first setup whatsapp through twilio to use this
                service. You will encounter errors when the service is not
                configured properly in twilio.</i
              >
            </b-form-checkbox>
            <div v-if="wardId !== null && !ward.twilio_test" class="mt-3 ml-2">
              <b-row class="mt-3 ml-1"
                >Twilio Phone Number callback URL(Copy and paste into Twilio
                Project):</b-row
              >
              <b-row class="ml-1 mt-2"
                ><pre>{{ webHookUrl }}</pre></b-row
              >
            </div>
            <div v-if="isInRole('canFetchContactCarriers')">
              <b-row class="mt-1 mb-3">
                <b-col>
                  <p>
                    <b-button
                      variant="secondary"
                      v-if="wardId !== null"
                      v-on:click="fetchCarriers"
                      >Fetch Contact Carriers</b-button
                    >
                    - Fetch contact mobile carriers for a more accurate message
                    cost estimates. Please note there is a cost
                    <b-badge variant="danger">$0.005</b-badge> per contact.<br />The
                    app will only fetch for this information once and store the
                    results per contact.
                  </p></b-col
                ></b-row
              >
            </div>
          </b-tab>
          <b-tab title="Public Settings">
            <b-form-checkbox
              v-model="ward.enable_public_signup"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Public Sign Up Enabled.<i
                >Enable users to signup through ward public signup page.</i
              >
            </b-form-checkbox>

            <b-form-checkbox
              v-model="ward.enable_public_appointments"
              name="check-button"
              class="mb-3 mt-3"
              switch
            >
              Public Appointment Booking Enabled.<i
                >Enable users to book appointments through the public appointment booking page.</i
              >
            </b-form-checkbox>

            <!-- Public SignUp QR Codes & Links -->
            <div v-if="wardId !== null && ward.enable_public_signup" class="mt-4">
              <h5>Public SignUp - QR Codes & Links</h5>
              <p class="text-muted">Share these QR codes and links with members in their preferred language</p>
              
              <b-row>
                <b-col 
                  v-for="lang in ward.supported_languages" 
                  :key="`signup-${lang}`"
                  cols="12" 
                  md="6" 
                  lg="4" 
                  class="mb-3"
                >
                  <b-card class="h-100" v-if="getLanguageLabel(lang)">
                    <div class="language-badge text-center mb-2">
                      <span class="mr-2">{{ getLanguageLabel(lang).flag }}</span>
                      <strong>{{ getLanguageLabel(lang).name }}</strong>
                    </div>
                    
                    <div class="qr-code-container">
                      <img 
                        :src="'data:image/png;base64,' + ward.public_qr_code" 
                        :alt="`QR Code for ${getLanguageLabel(lang).name}`"
                      />
                    </div>
                    
                    <div class="url-display">
                      {{ publicUrlWithLanguage(lang) }}
                    </div>
                    
                    <div class="action-buttons">
                      <b-button 
                        variant="primary" 
                        size="sm"
                        @click="copyToClipboard(publicUrlWithLanguage(lang), 'SignUp', getLanguageLabel(lang).name)"
                      >
                        <font-awesome-icon icon="clipboard" class="mr-1"/> Copy Link
                      </b-button>
                      <b-button 
                        variant="success" 
                        size="sm"
                        @click="downloadQrCode(getLanguageLabel(lang).code, 'signup')"
                      >
                        <font-awesome-icon icon="download" class="mr-1"/> Download QR
                      </b-button>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>

            <!-- Public Appointments QR Codes & Links -->
            <div v-if="wardId !== null && ward.enable_public_appointments" class="mt-4">
              <h5>Public Appointments - QR Codes & Links</h5>
              <p class="text-muted">Share these QR codes and links with members in their preferred language</p>
              
              <b-row>
                <b-col 
                  v-for="lang in ward.supported_languages" 
                  :key="`appointment-${lang}`"
                  cols="12" 
                  md="6" 
                  lg="4" 
                  class="mb-3"
                >
                  <b-card class="h-100" v-if="getLanguageLabel(lang)">
                    <div class="language-badge text-center mb-2">
                      <span class="mr-2">{{ getLanguageLabel(lang).flag }}</span>
                      <strong>{{ getLanguageLabel(lang).name }}</strong>
                    </div>
                    
                    <div class="qr-code-container">
                      <img 
                        :src="'data:image/png;base64,' + ward.public_appointment_qr_code" 
                        :alt="`QR Code for ${getLanguageLabel(lang).name}`"
                      />
                    </div>
                    
                    <div class="url-display">
                      {{ publicAppointmentUrlWithLanguage(lang) }}
                    </div>
                    
                    <div class="action-buttons">
                      <b-button 
                        variant="primary" 
                        size="sm"
                        @click="copyToClipboard(publicAppointmentUrlWithLanguage(lang), 'Appointment', getLanguageLabel(lang).name)"
                      >
                        <font-awesome-icon icon="clipboard" class="mr-1"/> Copy Link
                      </b-button>
                      <b-button 
                        variant="success" 
                        size="sm"
                        @click="downloadQrCode(getLanguageLabel(lang).code, 'appointment')"
                      >
                        <font-awesome-icon icon="download" class="mr-1"/> Download QR
                      </b-button>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
        <b-button type="submit" variant="primary" v-if="wardId !== null"
          >Update</b-button
        >
        <b-button type="submit" variant="primary" v-if="wardId === null"
          >Create</b-button
        >
      </b-form>
    </b-card>
  </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { StakeApi } from "@/app/stakes/stakeApi";
import { ROOT_URL } from "@/setup/constants";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
import _ from 'lodash';
export default {
  name: "WardDetail",
  props: {
    wardId: {
      type: String,
      required: false
    },
    stakeId: {
      type: String,
      required: false
    }
  },
  mixins: [userMixin],
  data() {
    return {
      showPublicQrCode: false,
      showPublicAppointmentQrCode: false,
      languageOptions: [],
      wardTypeOptions: [],
      appointmentTypeOptions: [],
      wardTimeZoneOptions: [],
      appointmentDefaults: {},
      contactSearchResults: {},
      contactSearchLoading: {},
      selectedAppointmentTypeToAdd: null,
      availableDayOptions: [
        { value: 'SUNDAY', text: 'Sunday' },
        { value: 'MONDAY', text: 'Monday' },
        { value: 'TUESDAY', text: 'Tuesday' },
        { value: 'WEDNESDAY', text: 'Wednesday' },
        { value: 'THURSDAY', text: 'Thursday' },
        { value: 'FRIDAY', text: 'Friday' },
        { value: 'SATURDAY', text: 'Saturday' }
      ],
      ward: {
        ward_id: null,
        stake_id: null,
        ward_name: null,
        ward_city: null,
        twilio_phone_number: null,
        twilio_id: null,
        twilio_password: null,
        twilio_test: false,
        use_ward_org_for_inbound: false,
        send_consent: false,
        throttle_sending_sms: false,
        throttle_interval_minutes: 5,
        throttle_max_messages: 60,
        ward_type: "STANDARD",
        supported_languages: [],
        fetch_contact_carrier: false,
        whatsapp_service_enabled: false,
        appointments_available: [],
        ward_timezone: null,
        enable_public_signup: false,
        enable_public_appointments: false,
        public_security_key: null,
        public_qr_code: null,
        public_appointment_qr_code: null,
        public_appointment_hours: {},
        public_appointments_defaults: {}
      }
    };
  },
  computed: {
    dayNames() {
      return ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    },
    availableLanguageOptions() {
      return this.languageOptions.filter(
        opt => this.ward.supported_languages.indexOf(opt.value) === -1
      );
    },
    availableAppointmentTypes() {
      return this.appointmentTypeOptions.filter(
        opt => this.ward.appointments_available.indexOf(opt.value) === -1
      );
    },
    appointmentTypesInDefaults() {
      // Get appointment types from defaults keys
      return Object.keys(this.appointmentDefaults);
    },
    availableAppointmentTypesToAdd() {
      // Show only appointment types that are not already in defaults
      return this.appointmentTypeOptions.filter(
        opt => !this.appointmentDefaults[opt.value]
      );
    },
    webHookUrl() {
      let hookUrl = `${ROOT_URL}`;
      let revisedHook = hookUrl;
      return `${revisedHook}/hook/${this.wardId}`;
    },
    publicUrl() {
      let publicUrl = `${location.protocol}//${location.host}`;
      this.ward.public_security_key = this.makeWardNameSafe();
      return `${publicUrl}/ward/${this.wardId}/public/signup/${this.ward.public_security_key}`;
    },
    publicAppointmentUrl() {
      let publicUrl = `${location.protocol}//${location.host}`;
      this.ward.public_security_key = this.makeWardNameSafe();
      return `${publicUrl}/ward/${this.wardId}/appointments/public/${this.ward.public_security_key}`;
    },
    publicUrlWithLanguage() {
      return (lang) => {
        const baseUrl = this.publicUrl;
        const langLabel = this.getLanguageLabel(lang);
        if (!langLabel) {
          console.warn('Could not resolve language label for:', lang);
          return `${baseUrl}?lang=en`;
        }
        return `${baseUrl}?lang=${langLabel.code}`;
      };
    },
    publicAppointmentUrlWithLanguage() {
      return (lang) => {
        const baseUrl = this.publicAppointmentUrl;
        const langLabel = this.getLanguageLabel(lang);
        if (!langLabel) {
          console.warn('Could not resolve language label for:', lang);
          return `${baseUrl}?lang=en`;
        }
        return `${baseUrl}?lang=${langLabel.code}`;
      };
    },
    languageLabels() {
      // Support both lowercase and capitalized language names
      const labels = {
        'english': { code: 'en', flag: '🇺🇸', name: 'English' },
        'spanish': { code: 'es', flag: '🇪🇸', name: 'Español' },
        'portuguese': { code: 'pt', flag: '🇧🇷', name: 'Português' }
      };
      
      // Create a case-insensitive lookup
      const normalized = {};
      Object.keys(labels).forEach(key => {
        normalized[key.toLowerCase()] = labels[key];
        // Also add capitalized version
        normalized[key.charAt(0).toUpperCase() + key.slice(1)] = labels[key];
      });      
      return normalized;
    }
  },
  async mounted() {
    if (this.wardId !== null) {
      this.ward = await this.getWard();
      await this.getQrCode();
      await this.getAppointmentQrCode();
      // Initialize hours dict if not present
      if (!this.ward.public_appointment_hours || typeof this.ward.public_appointment_hours !== 'object') {
        this.ward.public_appointment_hours = {};
      }
      // Ensure each day has at least an empty array
      this.dayNames.forEach(day => {
        if (!this.ward.public_appointment_hours[day]) {
          this.$set(this.ward.public_appointment_hours, day, []);
        }
      });
    } else {
      // Initialize empty hours for new ward
      this.ward.public_appointment_hours = {};
      this.dayNames.forEach(day => {
        this.$set(this.ward.public_appointment_hours, day, []);
      });
    }
    
    // Initialize appointment defaults
    if (this.ward.public_appointments_defaults) {
      // Convert defaults from backend format to UI format
      const loadDefaultsPromises = Object.keys(this.ward.public_appointments_defaults).map(async (appointmentType) => {
        const defaultConfig = this.ward.public_appointments_defaults[appointmentType];
        let organizer = null;
        
        // Load organizer contact if contact_id is set
        if (defaultConfig.optional_organizer_contact_id && this.wardId) {
          try {
            const { data } = await WardApi.getWardContact(this.wardId, defaultConfig.optional_organizer_contact_id);
            organizer = {
              contact_id: data.contact_id,
              full_name: `${data.first_name} ${data.last_name}`,
              first_name: data.first_name,
              last_name: data.last_name,
              title: data.title,
              phone_number: data.phone_number
            };
          } catch (e) {
            // Contact not found or error - leave as null
            console.warn(`Could not load organizer contact ${defaultConfig.optional_organizer_contact_id} for ${appointmentType}:`, e);
          }
        }
        
        // Convert available days from enum values to strings
        let availableDays = [];
        if (defaultConfig.optional_available_days && defaultConfig.optional_available_days.length > 0) {
          defaultConfig.optional_available_days.forEach(day => {
            if (typeof day === 'string') {
              availableDays.push(day);
            } else if (day && day.value) {
              availableDays.push(day.value);
            }
          });
        }
        
        this.$set(this.appointmentDefaults, appointmentType, {
          organizer: organizer,
          emails: defaultConfig.optional_notification_emails || [],
          availableDays: availableDays,
          maxAppointments: defaultConfig.max_appointments_per_slot || 3,
          duration: (defaultConfig.appointment_lengths && defaultConfig.appointment_lengths[appointmentType]) || 15
        });
      });
      
      await Promise.all(loadDefaultsPromises);
    }
    
    // Initialize contact search state for each appointment type in defaults
    Object.keys(this.appointmentDefaults).forEach(appointmentType => {
      this.$set(this.contactSearchResults, appointmentType, []);
      this.$set(this.contactSearchLoading, appointmentType, false);
    });
    
    this.wardTypeOptions = this.$store.state.frontEndSettings.ward_types;
    this.languageOptions = this.$store.state.frontEndSettings.application_languages;
    this.appointmentTypeOptions = this.$store.state.frontEndSettings.appointment_types;
    // fetchTimeZones
    const timeZones = Intl.supportedValuesOf("timeZone");
    timeZones.forEach(timeZone => {
      this.wardTimeZoneOptions.push({
        value: timeZone,
        text: timeZone
      });
    });
  },
  methods: {
    getLanguageLabel(lang) {
      if (!lang) return null;
      // Handle both string and object types
      const langString = typeof lang === 'string' ? lang : (lang.value || lang.name || String(lang));
      const lang_code_mapping = {
        'ENG': 'english',
        'SPA': 'spanish',
        'POR': 'portuguese'
      };
      const mapLangString = lang_code_mapping[langString] || langString;
      const normalizedLang = langString.toLowerCase();
      return this.languageLabels[mapLangString] || this.languageLabels[normalizedLang] || this.languageLabels[langString] || {
        code: 'en',
        flag: '🌐',
        name: langString
      };
    },
    async getWard() {
      try {
        const { data } = await WardApi.getWardDetail(this.wardId);
        return data.ward;
      } catch (e) {
        handleError(e, "Error trying to get Ward Information");
      }
    },
    async getQrCode() {
      try {
        const { data } = await WardApi.getWardPublicQrCode(this.wardId);
        this.ward.public_qr_code = data.ward_qr_code;
      } catch (e) {
        handleError(e, "Error trying to get Ward QR Code");
      }
    },
    async getAppointmentQrCode() {
      try {
        const { data } = await WardApi.getWardPublicAppointmentQrCode(this.wardId);
        this.ward.public_appointment_qr_code = data.ward_qr_code;
      } catch (e) {
        handleError(e, "Error trying to get Ward Appointment QR Code");
      }
    },
    async onSubmit(event) {
      event.preventDefault();
      try {
        // Prepare defaults for save
        this.ward.public_appointments_defaults = this.prepareDefaultsForSave();
        
        if (this.wardId !== null) {
          const { data } = await WardApi.updateWard(this.wardId, this.ward);
          this.$toast.success("Updated ward successfully");
        } else {
          this.ward.stake_id = this.stakeId;
          const { data } = await StakeApi.createWard(this.stakeId, this.ward);
          this.ward = data;
          this.$toast.success("Created ward successfully");
        }
        this.$router.push({
          name: "ward-list",
          params: { wardId: this.ward.ward_id }
        });
      } catch (e) {
        handleError(e, "Error trying process Ward request");
      }
    },
    async fetchCarriers() {
      try {
        if (this.wardId !== null) {
          // Bail out when the ward is in test mode
          if (this.ward.twilio_test) {
            this.$toast.warning(
              "The ward is in test mode and will not go fetch carriers!"
            );
            return;
          }
          const { data } = await WardApi.fetchCarriers(this.wardId);
          this.$toast.success("Started fetching of carriers for ward contacts");
        }
      } catch (e) {
        handleError(e, "Error trying process Ward request");
      }
    },
    makeWardNameSafe: function() {
      if (this.ward.ward_name === null) return "";
      return this.ward.ward_name.toLowerCase().replaceAll(" ", "-");
    },
    getDayHours(dayName) {
      if (!this.ward.public_appointment_hours) {
        this.$set(this.ward, 'public_appointment_hours', {});
      }
      if (!this.ward.public_appointment_hours[dayName]) {
        this.$set(this.ward.public_appointment_hours, dayName, []);
      }
      return this.ward.public_appointment_hours[dayName];
    },
    addHour(dayName) {
      if (!this.ward.public_appointment_hours) {
        this.$set(this.ward, 'public_appointment_hours', {});
      }
      if (!this.ward.public_appointment_hours[dayName]) {
        this.$set(this.ward.public_appointment_hours, dayName, []);
      }
      this.ward.public_appointment_hours[dayName].push("09:00");
    },
    removeHour(dayName, hourIndex) {
      if (this.ward.public_appointment_hours[dayName] && this.ward.public_appointment_hours[dayName].length > hourIndex) {
        this.ward.public_appointment_hours[dayName].splice(hourIndex, 1);
      }
    },
    getAppointmentTypeDescription(appointmentType) {
      const option = this.appointmentTypeOptions.find(opt => opt.value === appointmentType);
      return option ? option.text : appointmentType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
    getDefaultForType(appointmentType) {
      if (!this.appointmentDefaults[appointmentType]) {
        this.$set(this.appointmentDefaults, appointmentType, {
          organizer: null,
          emails: [],
          availableDays: [],
          maxAppointments: 3,
          duration: 15
        });
      }
      return this.appointmentDefaults[appointmentType];
    },
    getContactSearchResults(appointmentType) {
      return this.contactSearchResults[appointmentType] || [];
    },
    getContactSearchLoading(appointmentType) {
      return this.contactSearchLoading[appointmentType] || false;
    },
    contactPrettyDisplay(contact) {
      if (!contact) return '';
      const title = contact.title ? `${contact.title} ` : '';
      return `${title}${contact.full_name || `${contact.first_name} ${contact.last_name}`}`;
    },
    searchContacts: _.debounce(async function(term, appointmentType) {
      if (term === null || term === "") {
        return;
      }

      let payload = {
        aux_id: null,
        pk_id: null,
        gsi_pk: null,
        gsi_sk: null,
        org_filter: "WARD",
        search_term: term
      };
      
      this.$set(this.contactSearchLoading, appointmentType, true);
      try {
        const { data } = await WardApi.getWardList(this.wardId, payload);
        this.convertToLightContact(data.contact_list, appointmentType);
      } catch (e) {
        handleError(e, "Error searching contacts");
      } finally {
        this.$set(this.contactSearchLoading, appointmentType, false);
      }
    }, 500),
    convertToLightContact(contact_list, appointmentType) {
      const results = [];
      contact_list.forEach(item => {
        let lightContact = {
          full_name: `${item.first_name} ${item.last_name}`,
          first_name: item.first_name,
          last_name: item.last_name,
          title: item.title,
          contact_id: item.contact_id,
          phone_number: item.phone_number,
          send_through_whatsapp: item.send_through_whatsapp,
        };
        results.push(lightContact);
      });
      this.$set(this.contactSearchResults, appointmentType, results);
    },
    clearSearchResults(appointmentType) {
      this.$set(this.contactSearchResults, appointmentType, []);
    },
    addAppointmentType() {
      if (this.selectedAppointmentTypeToAdd && !this.appointmentDefaults[this.selectedAppointmentTypeToAdd]) {
        // Add to defaults
        this.$set(this.appointmentDefaults, this.selectedAppointmentTypeToAdd, {
          organizer: null,
          emails: [],
          availableDays: [],
          maxAppointments: 3,
          duration: 15
        });
        // Initialize contact search state
        this.$set(this.contactSearchResults, this.selectedAppointmentTypeToAdd, []);
        this.$set(this.contactSearchLoading, this.selectedAppointmentTypeToAdd, false);
        // Reset selection
        this.selectedAppointmentTypeToAdd = null;
      }
    },
    removeAppointmentType(appointmentType) {
      if (confirm(`Are you sure you want to remove "${this.getAppointmentTypeDescription(appointmentType)}"? This will make it unavailable for public booking.`)) {
        // Remove from defaults
        this.$delete(this.appointmentDefaults, appointmentType);
        // Clean up contact search state
        this.$delete(this.contactSearchResults, appointmentType);
        this.$delete(this.contactSearchLoading, appointmentType);
      }
    },
    prepareDefaultsForSave() {
      // Convert UI format back to backend format
      // All types in appointmentDefaults are available for booking
      const defaults = {};
      Object.keys(this.appointmentDefaults).forEach(appointmentType => {
        const defaultConfig = this.appointmentDefaults[appointmentType];
        
        // Build appointment_lengths dict from all configured types
        const appointmentLengths = {};
        Object.keys(this.appointmentDefaults).forEach(type => {
          const duration = this.appointmentDefaults[type].duration;
          if (duration && duration !== 15) { // Only include non-default values
            appointmentLengths[type] = duration;
          }
        });
        
        defaults[appointmentType] = {
          appointment_type: appointmentType,
          optional_organizer_contact_id: defaultConfig.organizer ? defaultConfig.organizer.contact_id : null,
          optional_notification_emails: defaultConfig.emails || [],
          optional_available_days: defaultConfig.availableDays || [],
          max_appointments_per_slot: defaultConfig.maxAppointments || 3,
          appointment_lengths: appointmentLengths
        };
      });
      return defaults;
    },
    async copyToClipboard(text, type, lang) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.success(`${type} link (${lang}) copied to clipboard!`);
      } catch (e) {
        this.$toast.error('Failed to copy to clipboard');
      }
    },
    downloadQrCode(langCode, type) {
      const qrCode = type === 'signup' 
        ? this.ward.public_qr_code 
        : this.ward.public_appointment_qr_code;
      
      // Convert base64 to blob
      const byteString = atob(qrCode);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }
      
      const blob = new Blob([uint8Array], { type: 'image/png' });
      const url = URL.createObjectURL(blob);
      
      // Create download link
      const link = document.createElement('a');
      link.href = url;
      link.download = `${this.ward.ward_name}-${type}-${langCode}-qr.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      this.$toast.success(`QR Code downloaded!`);
    }
  }
};
</script>
<style lang="scss" scoped>
.language-badge {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}

.qr-code-container {
  text-align: center;
  padding: 1rem 0;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1rem;
  
  img {
    max-width: 200px;
    height: auto;
  }
}

.url-display {
  background: #f8f9fa;
  padding: 0.75rem;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.875rem;
  word-break: break-all;
  margin-bottom: 1rem;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  
  button {
    flex: 1;
  }
}

@media (max-width: 767px) {
  .qr-code-container img {
    max-width: 150px;
  }
}
</style>
